module.exports = __webpack_public_path__ + "img/edit.5586796c.svg";